import React from 'react';
import { ItemProps } from 'react-virtuoso';
import { ListItemButtonProps } from '@mui/material';
import { StyledParticipantListItem } from 'components/participants-list/styled';
import { ContentLibraryUsersVirtualListItemType } from 'features/content-library/selectors/selectContentLibraryActiveUsers';
import { ShareUsersListContext } from 'features/content-library/components/share-users-selector/ShareFileUsersList';

type ShareUsersListItemProps = ListItemButtonProps<
  'li',
  ItemProps<ContentLibraryUsersVirtualListItemType> & {
    context: ShareUsersListContext;
  }
>;

const ShareFileUsersListItem = React.forwardRef<HTMLLIElement, ShareUsersListItemProps>(
  ({ children, item, context, ...props }, ref) => (
    <StyledParticipantListItem {...props} ref={ref}>
      {children}
    </StyledParticipantListItem>
  )
);

export default ShareFileUsersListItem;
